export {DOMAIN, COVERAGE, COVERAGECOLLECTION} from 'covutils'
export const LINKRELPREFIX = 'http://www.iana.org/assignments/relation/'